import overrideTableStyles from './Table';


const overrideComponents = theme => Object.assign(
	overrideTableStyles(theme)
)

export default overrideComponents;